import type { RiskAssessmentResultControlType } from '@risksmart-app/domain/src/types/consts/risk-assessment-result-control-type';
import type { RiskAssessmentResultsByRiskIdResponseRow } from '@risksmart-app/trpc/src/types';
import type { GetRiskAssessmentResultsByRiskIdAndControlTypeQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetRiskAssessmentResultsByRiskIdAndControlTypeDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createLazyQueryHook } from 'src/utils';

type UseGetRiskAssessmentResultsByRiskIdAndControlTypeArgs = {
  RiskId: string;
  ControlType: RiskAssessmentResultControlType;
};

export const useLazyGetRiskAssessmentResultsByRiskIdAndControlType =
  createLazyQueryHook<
    UseGetRiskAssessmentResultsByRiskIdAndControlTypeArgs,
    RiskAssessmentResultsByRiskIdResponseRow[],
    GetRiskAssessmentResultsByRiskIdAndControlTypeQuery
  >({
    trpcQuery: (client, args) =>
      client.frontend.assessment.riskAssessmentResultsByRiskIdAndControlType.query(
        {
          riskId: args.RiskId,
          controlType: args.ControlType,
        }
      ),
    mapTrpcDataToGraphQL: (data) => ({ risk_assessment_result: data }),
    graphqlDocument: GetRiskAssessmentResultsByRiskIdAndControlTypeDocument,
    graphqlVariables: (args) => ({
      RiskId: args.RiskId,
      ControlType: args.ControlType,
    }),
  });
